var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FEE2E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 13.3333V32L17.0665 27.2C17.5276 26.8528 18.0893 26.6656 18.6665 26.6666H29.3332C30.8059 26.6666 31.9998 25.4727 31.9998 24V13.3333C31.9998 11.8605 30.8059 10.6666 29.3332 10.6666H13.3332C11.8604 10.6666 10.6665 11.8605 10.6665 13.3333ZM13.3332 26.6666V13.3333H29.3332V24H17.7785C17.2013 23.9984 16.6394 24.1857 16.1785 24.5333L13.3332 26.6666Z",
    fill: "#DB0A3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 37.3333V20C37.3332 18.5272 36.1393 17.3333 34.6665 17.3333V32L31.8212 29.8666C31.3603 29.519 30.7984 29.3317 30.2212 29.3333H17.3332C17.3332 30.8061 18.5271 32 19.9998 32H29.3332C29.9103 31.9989 30.4721 32.1861 30.9332 32.5333L37.3332 37.3333Z",
    fill: "#DB0A3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedChat);
export default __webpack_public_path__ + "static/media/red-chat.e9d7eff0.svg";
export { ForwardRef as ReactComponent };